import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  DashboardOutlined,
  ThunderboltOutlined,
  FieldTimeOutlined,
  AlertOutlined,
  FileTextOutlined,
  BugOutlined,
  SettingOutlined,
  CustomerServiceOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

const { Sider } = Layout;

export default function Sidebar({ collapsed }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Sider
      width={250}
      collapsed={collapsed}
      collapsedWidth={72}
      style={{
        background: "#06111f",
        height: "100vh",
        position: "sticky",
        top: 0,
      }}
    >
      <div style={{ padding: collapsed ? 16 : 22, color: "#fff" }}>
        <div style={{ fontSize: collapsed ? 18 : 22, fontWeight: 800 }}>
          ⚡ {!collapsed && "ExxoCharge"}
        </div>
        {!collapsed && (
          <div style={{ color: "#8fa3bf", fontSize: 12 }}>
            OCPP Command Center
          </div>
        )}
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={({ key }) => {
  if (key === "/logout") {
    localStorage.removeItem("navedge_auth");
    localStorage.removeItem("navedge_user");
    navigate("/login");
    return;
  }
  navigate(key);
}}
        style={{ background: "#06111f", borderRight: 0 }}
        items={[
          { key: "/", icon: <DashboardOutlined />, label: "Dashboard" },
          { key: "/chargers", icon: <ThunderboltOutlined />, label: "Chargers" },
          { key: "/sessions", icon: <FieldTimeOutlined />, label: "Live Sessions" },
          { key: "/alerts", icon: <AlertOutlined />, label: "Alerts" },
          { key: "/reports", icon: <FileTextOutlined />, label: "Reports" },
          { key: "/debug", icon: <BugOutlined />, label: "OCPP Debug" },
          { key: "/admin", icon: <SettingOutlined />, label: "Administration" },
          { key: "/support", icon: <CustomerServiceOutlined />, label: "Support" },
          { key: "/logout", icon: <LogoutOutlined />, label: "Logout", danger: true },
        ]}
      />
    </Sider>
  );
}